<app-loader loaderId="pageLoader" size="large"></app-loader>
<router-outlet></router-outlet>